{
  "chart": "AGGREGATION",
  "map": "GEOLOCATION",
  "table": "FINDANDPAGINATE",
  "tender-list-tile": "FINDANDPAGINATE"
}
